<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>企业认证信息</span>
      </div>
      <div id="nav">
        <ul class="user-info-list">
          <li>
            <em>公司名称:&#12288;&#12288;&#12288;&#12288;</em><span>{{ userInfoList.companyName }}</span>
          </li>
          <li>
            <em>法人/代理人姓名:&#12288;</em><span>{{ userInfoList.legalName }}</span>
          </li>
          <li>
            <em>统一社会信用代码:</em><span>{{ userInfoList.organization }}</span>
          </li>
          <li>
            <em>审核时间:&#12288;&#12288;&#12288;&#12288;</em><span>{{ userInfoList.auditorTime }}</span>
          </li>
          <li>
            <em>认证状态:&#12288;&#12288;&#12288;&#12288;</em>
            <span v-if="userInfoList.status == 0">未认证</span>
            <span v-if="userInfoList.status == 1">管理员资料已提交</span>
            <span v-if="userInfoList.status == 2">企业基本资料(没有申请表)已提交</span>
            <span v-if="userInfoList.status == 3">已提交待审核</span>
            <span v-if="userInfoList.status == 4">审核通过</span>
            <span v-if="userInfoList.status == 5">审核不通过</span>
            <span v-if="userInfoList.status == 6">人工初审通过</span>
          </li>
        </ul>
      </div>
    </el-card>
  </div>
</template>

<script>
import { userinfoLoginApi } from '../../api/getData'
import { getPersonAuthStatusApi } from '../../api/getData'
import { getVerifyStatusApi } from '../../api/getData'

export default {
  data() {
    return {
      userInfoList: {
        companyName: '',
        legalName: '',
        organization: '',
        auditorTime: '',
        status: ''
      }
    }
  },
  computed: {
    getToken() {
      return this.$store.state.token
    }
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event)
    },
    getAuthInfo() {
      //调用信息查询接口
      userinfoLoginApi(this.getToken).then(res => {
        res = res.data
        if (res.code === 0) {
          let cid = res.data.customerId
          //调用认证交易号查询接口
          getPersonAuthStatusApi(cid).then(res => {
            res = res.data
            console.info('调用认证交易号查询接口>>>>>' + res)
            if (res.code === 0) {
              //let serialNo = res.data.serialNo
              //根据交易号，调用查询企业实名认证状态接口
              getVerifyStatusApi('2').then(res => {
                res = res.data
                console.info('查询企业实名认证状态接口>>>>>' + res)
                if (res.code === 0) {
                  console.info('查询成功' + res.data)
                  this.userInfoList.companyName = res.data.company.companyName
                  this.userInfoList.legalName = res.data.company.legalName
                  this.userInfoList.organization = res.data.company.organization
                  this.userInfoList.auditorTime = res.data.company.auditorTime
                  this.userInfoList.status = res.data.company.status
                  console.info(res)
                } else {
                  this.$message({
                    type: 'warning',
                    message: res.msg
                  })
                }
              })
            } else {
              this.$message({
                type: 'warning',
                message: res.msg
              })
            }
          })
        }
      })
    }
  },
  created() {
    this.getAuthInfo()
  }
}
</script>

<style lang="scss" scoped>
.user-info-list {
  line-height: 40px;
}
span {
  margin-left: 50px;
}

#nav {
  justify-content: space-between;
}

.authentic1 {
  font-size: medium;
  color: red;
}
.authentic2 {
  font-size: medium;
  color: rgb(33, 236, 33);
}
.box-card {
  height: 100%;
  width: 90%;
}
</style>
